import { TFunction } from 'i18next';

export const getPreferenceSounds = (t: TFunction) => [
  {
    name: t('Mute'),
    value: '',
  },
  {
    name: t('Pop Ding'),
    value: 'Pop Ding',
  },
  {
    name: t('Bongo Drum'),
    value: 'Bongo Drum',
  },
  {
    name: t('Jingle Bells'),
    value: 'Jingle Bells',
  },
  {
    name: t('Ding Dong'),
    value: 'Ding Dong',
  },
  {
    name: t('Flute'),
    value: 'Flute',
  },
  {
    name: t('Piano'),
    value: 'Piano',
  },
];
